// components/AdminDataExport/AdminDataExport.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Button } from '../UI/Button.js';
import { Dropdown } from '../UI/Dropdown.js';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';
import Select from 'react-select'; // Import react-select

const AdminDataExport = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [day, setDay] = useState('');

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const isOptionSelected = (option) => {
    return selectedEmployees.some(selected => selected.value === option.value);
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await api.get('/userlist');
        setEmployees(response.data.map(emp => ({ value: emp.user_id, label: `${emp.name} ${emp.surnames}` })));
      } catch (error) {
        console.error('Failed to fetch employees', error);
      }
    };
    fetchEmployees();
  }, []);

  const handleExport = async () => {
    try {
      let url = '/export';
      const params = new URLSearchParams();
      if (year) params.append('year', year);
      if (month) params.append('month', month);
      if (day) params.append('day', day);
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const payload = {
        employee_ids: selectedEmployees.map(emp => emp.value),
      };

      const response = await api.post(url, payload, { responseType: 'blob' });

      // Create a download link
      const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlBlob;
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'download.xlsx';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename\*?="?([^";]+)"?/);
        if (filenameMatch && filenameMatch.length > 1) {
          filename = filenameMatch[1];
        }
      }
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error('Data export failed', error);
      alert('Data export failed. Please check the inputs.');
    }
  };

  return (
    <div>
      <h2>Admin Data Export</h2>
      <FormContainer>
        <FullWidth>
          <Select
            isMulti
            options={employees}
            value={selectedEmployees}
            onChange={(selectedOptions) => setSelectedEmployees(selectedOptions)}
            placeholder="Selecciona empleado/s"
			isOptionSelected={isOptionSelected}
			closeMenuOnSelect={false}
          />
        </FullWidth>
        <FullWidth>
          <Dropdown value={year} onChange={(e) => setYear(e.target.value)} required >
            <option value="">Año</option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Dropdown value={month} onChange={(e) => setMonth(e.target.value)} >
            <option value="">Mes</option>
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Dropdown value={day} onChange={(e) => setDay(e.target.value)}>
            <option value="">Día</option>
            {days.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Button onClick={handleExport}>Export</Button>
        </FullWidth>
      </FormContainer>
    </div>
  );
};

export default AdminDataExport;